/**
 * Project module UI labels
 * These are default labels that can be overridden per company
 */
export const PROJECT_LABELS = {
  location: "Location",
  locationAddress: "Location Address",
  client: "Client",
  clientAddress: "Client Address",
  project: "Project",
  projects: "Projects",
  work: "Work",
  works: "Works",
  createProject: "Create Project",
  editProject: "Edit Project",
  projectDetails: "Project Details",
  workSite: "Work Site",
  workInformation: "Work Information",
  startDateTime: "Date and Time",
  pricingDetails: "Pricing Details",
  requiredSkills: "Required Skills",
  requiredCertifications: "Required Certifications",
  assignManager: "Assign Work Manager",
  tasks: "Tasks",
  additionalInformation: "Additional Information",
  scopeOfWork: "Scope of Work",
  selectLocation: "Select a saved Location",
  addNewLocation: "+ Add New Location",
  selectClient: "Select a saved Client",
  addNewClient: "+ Add New Client",
  locationType: "Location Type",
  siteNumber: "Site Number/Location name",
  clientName: "Client Name",
  numberOfIPsRequired:
    "How many Independent Professional's do you need? Please select at least one",
  numberOfIPsRequiredShort: "Number of IPs Required",
  paymentType: "Payment Type",
  confidentialInformation: "Confidential Information (optional)",
  workManagement: "Work Management",
  draft: "Draft",
  openWork: "Open Work",
  scheduled: "Scheduled",
  inProgress: "In-Progress",
  completed: "Completed",
  cancelled: "Cancelled",
  templates: "Templates",
  createNewTemplate: "Create New Template",
  workIdWorkTitle: "Work ID# - Work Title",
  lastUpdate: "Last Update",
  viewEditDelete: "View/Edit/Delete",
  editTemplate: "Edit Template",
  requirements: "Requirements",
  additionalSettings: "Additional Settings",
  metadata: "Metadata",
  skills: "Skills",
  certifications: "Certifications",
  notRequired: "Not Required",
  numberOfIPs: "Number of IPs",
  estimatedAmountOfHours: "Estimated Amount of Hours",
  photosRequired: "Photo(s) Required",
  finalNotesRequired: "Final Notes Required",
  toolsRequired: "Tool(s) Required",
  mileRadius: "Mile Radius",
  backgroundCheckRequired: "Background Check Required",
  drugTestRequired: "Drug Test Required",
  createdAt: "Created At",
  hourly: "Hourly",
  fixedRate: "Fixed Rate",
  independentProfessional: "Independent Professional",
  independentProfessionals: "Independent Professional(s)",
  bulkUploadWork: "Bulk Upload Work",
  uploadMultipleWorks: "Upload multiple works at once using a CSV file",
  overview: "Overview",
  chats: "Chats",
  internalNotes: "Internal Notes",
  changeWorkManager: "Change Work Manager",
  publishWork: "Publish Work",
  workDocuments: "Work Documents",
  noDocumentsSpecified: "No documents specified",
  viewDocument: "View Document",
  uploadDocument: "Upload Document",
  startTime: "Start Time",
  reasonSchedule: "Reason schedule",
  noTasksSpecified: "No tasks specified",
  pricing: "Pricing",
  fixedRateLabel: "Fixed Rate",
  hourlyRate: "Hourly Rate",
  yes: "Yes",
  no: "No",
  workId: "Work Id",
  workName: "Work Name",
  private: "Private",
  startAt: "Start At",
  offers: "Offers",
  invites: "Invites",
  cancelReason: "Cancel Reason",
  details: "Details",
  openDetail: "Open Detail",
  showMap: "Show Map",
  bulkUpload: "Bulk Upload",
  createNewWork: "Create New Work",
  uploadDocuments: "Upload Documents",
  refresh: "Refresh",
  assignedIndependentProfessional: "Assigned Independent Professional",
  independentProfessionalEmail: "Independent Professional Email",
  independentProfessionalPhone: "Independent Professional Phone #",
  eventName: "Event Name",
  user: "User",
  time: "Time",
  unableToFindTalent: "Unable to find hired/completed talent on this project!",
  joinedChatRoom: "You've joined the chat room",
  fileSizeTooSmall: "File size is too small!",
  fileSizeTooLarge: "File size is too large!",
  problemReadingFile: "Problem occured while reading file!",
  tooManyFiles: "Too many files",
  notEnoughFiles: "Not enought files",
  rate: "Rate",
  maxHour: "Max Hour",
  moreDetail: "More Detail",
  workMap: "Work Map",
  noWorkYet: "No Work, yet",
  title: "Title",
  // Create Job page labels
  whereIsWorkSite: "Where is the Work Site?",
  enterSOW: "Enter SOW",
  sowDescription: "SOW – add the Description/Scope of Work",
  dateTimeInstructions:
    "Please enter Date and Time of the work according to selected time zone.",
  startManagingTime: "Start Managing Time",
  selectTimezoneOfWork: "Select timezone of the work",
  bulkUploadTitle: "Bulk Upload",
  templateTitle: "Template",
  templateInstructions:
    "If you have a template created, please Click the Checkbox and Select an option.",
  selectTemplate: "Select Template",
  loadingTemplate: "Loading template...",
  customizeLayout: "Customize Layout",
  assignWorkManagerForWork: "Assign the Work Manager for this work",
  selectWorkManager: "Select Work Manager",
  whatSkillsLookingFor: "What skills are you looking for?",
  selectSearchSkills: "Select/Search Skills",
  requiredCertificationsOptional: "Required Certifications (optional)",
  selectCertifications: "Select Certifications",
  tasksOptionalNote:
    "Tasks - Note: this is just in case you need them to do a special assigment (optional)",
  addTask: "Add Task",
  typeHourlyRate: "Type the Hourly Rate",
  enterFixedRate: "Please enter the fixed rate",
  worksiteRadiusMiles: "Worksite Radius (miles)",
  onlyAvailableToIPsWithinRadius: "Only available to IPs within radius",
  privateOnlyInvitedIPs: "Private -  only invited IPs will be able to view",
  publicAllIPs: "Public - all IPs will be able to view",
  photosRequiredNote:
    "Photo(s) Required - IPs must submit photo(s) of their work. Specify details in Scope of Work",
  finalNotesRequiredNote:
    "Final Notes Required - IPs must submit final notes of their work. Specify details in Scope of Work",
  toolsRequiredNote:
    "Tool(s) Required - IPs need to provide their own tool(s). Specify details in Scope of Work",
  backgroundCheckRequiredLabel: "Background check required",
  drugTestRequiredLabel: "Drug test required",
  confidentialInformationNote:
    "Enter any Confidential Information - Note: This will only be seen once the Independent Professional is hired by the Customer. (optional)",
  goTo: "Go to:",
  selectAManager: "Select a Manager",
  finalStepAdditionalInformation: "Final Step: Additional Information",
  addCertificationsIfNeeded: "Add Certifications (if needed)",
  addTasksIfNeeded: "Add Tasks (if needed)",
  // Status labels
  draftStatus: "DRAFT",
  publishedStatus: "PUBLISHED",
  scheduledStatus: "SCHEDULED",
  inProgressStatus: "IN PROGRESS",
  completedStatus: "COMPLETED",
  cancelledStatus: "CANCELLED",
  // Action labels
  workPublished: "Work published",
  workCompleted: "Work completed!",
  cancelWork: "Cancel Work",
  completeWork: "Complete Work",
  publishWorkQuestion: "Publish Work?",
  completeWorkQuestion: "Complete & Finish the Work?",
  privatePosting: "Private Posting",
  publicPosting: "Public Posting",
  inviteIndependentProfessional: "+ Invite Independent Professional",
  // Modal form labels
  sendOtherExpenses: "Send Other Expenses",
  bonus: "Bonus",
  additionalHours: "Additional Hours",
  reimbursement: "Reimbursement",
  selectType: "Select Type",
  amount: "Amount ($)",
  reason: "Reason",
  otherExpensesSentSuccessfully: "Other expenses successfully sent! Thank You!",
  pleaseEnterValidAmount: "Please enter a valid amount",
  pleaseProvideReason: "Please provide a reason",
  recordOtherExpensesDescription: "Record bonuses, additional hours, or reimbursements for this independent professional.",
  cancelProject: "Cancel Project",
  selectCancelReason: "Select Cancel Reason",
  projectCanceled: "Project canceled!",
  removeIndependentProfessional: "Remove Independent Professional",
  independentProfessionalCanceled: "Independent Professional canceled!",
  jobInternalNotes: "Job Internal Notes",
  notes: "Notes",
  notVisibleToIP: "*Not visible to Independent Professional",
  professionalsWorkReview: "Professional's Work Review",
  selectReviewReason: "Select review reason",
  workRejected: "Independent Professional's work rejected!",
  editStartTime: "Edit Start Time",
  startWorkingTime: "Start Working Time",
  selectRescheduleReason: "Select Reschedule Reason",
  createTask: "Create Task",
  editTask: "Edit Task",
  taskName: "Task Name",
  taskDescription: "Task Description",
  uploadDocumentsDescription: "Upload documents and select the Work IDs where you want it to be attached",
  chooseFile: "Choose file",
  attachingFileToProject: "Attaching file to project with ID number",
  uploadSuccessful: "Upload Successful",
  pleaseChooseFile: "Please choose a file",
  loadingWork: "Loading work...",
  completeWorkHelperText: "Complete & Finish the Work?",
  // ModalTalentDetail labels
  matchScore: "Match Score",
  totalScore: "Total Score",
  skillMatch: "Skill Match",
  distance: "Distance",
  available: "Available",
  currentlyHired: "Currently Hired",
  nA: "N/A",
  noAvailabilitySet: "No availability set",
  position: "Position",
  yearsOfExperience: "Years of Experience",
  matchedWithProject: "Matched with Project",
  otherSkills: "Other Skills",
  notMatched: "Not Matched",
  joinChat: "Join Chat",
  typeMessageHere: "Type message here",
  createTemplateFromThisWork: "Create Template From This Work",
} as const;

export type ProjectLabelKey = keyof typeof PROJECT_LABELS;
